export default {
  open: "OPEN",
  lockedByForeman: "LOCKED_BY_FOREMAN",
  locked: "LOCKED",
  approved: "APPROVED",
  deleted: "DELETED",
};
